// src/components/AccountCreation/Step4_Confirmation.js
import React, { useState, useEffect } from 'react';
import { PLAN_FEATURES } from './constants';

const formatDate = (dateString) => {
    const date = new Date(dateString + 'T00:00:00');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

const PlanSelectionCard = ({ tier, deviceTypeId, currentSelection, onSelect, displayFrequency }) => {
    const cleanTierName = (name) => name ? name.replace('Acuma', '').replace('SUBS_', '').replace('Intl', '') : '';
    const name = cleanTierName(tier.tierName);



    const devicePlans = tier.plans.filter(p => p.deviceTypeId === deviceTypeId);
    //const devicePlans = tier.plans;

    const frequencies = [...new Set(devicePlans.map(p => p.paymentFrequency.frequency))].sort((a, b) => {
        const order = ['MONTHLY', 'QUARTERLY', 'SEMI ANNUALLY', 'ANNUALLY', 'ONE TIME PURCHASE'];
        return order.indexOf(a) - order.indexOf(b);
    });

    const planToShow = devicePlans.find(p => p.paymentFrequency.frequency === displayFrequency) || devicePlans[0];
    if (!planToShow) return null;

    //const planToShow = devicePlans;

    const isSelected = tier.tierName === currentSelection.tierName && displayFrequency === currentSelection.frequency;

    const getIntervalUnit = (frequency) => {
        switch (frequency) {
            case 'MONTHLY': return '/month';
            case 'QUARTERLY': return '/3months';
            case 'SEMI ANNUALLY': return '/6months';
            case 'ANNUALLY': return '/year';
            case 'ONE TIME PURCHASE': return '/one-time';
            default: return '';
        }
    }

    console.log("planToShow...", planToShow)

    return (
        <div className={`plan-selection-card card plan-${name.toLowerCase()} h-100 ${isSelected ? 'selected' : ''}`} onClick={() => onSelect(tier.tierName, planToShow.id)}>
            <div className="card-body d-flex flex-column text-center p-4">
                {isSelected && <div className="selected-tick"><i className="bi bi-check-circle-fill"></i></div>}
                <h5 className="card-title fw-bold h4" style={{ color: "white" }}>{name}</h5>

                <div className="frequency-toggle btn-group btn-group-sm d-flex my-3" role="group">
                    {frequencies.map(freq => {
                        const planForFreq = devicePlans.find(p => p.paymentFrequency.frequency === freq);
                        if (!planForFreq) return null;
                        const label = freq.replace(' ANNUALLY', '').replace(' PURCHASE', '');
                        return (
                            <button
                                key={freq}
                                type="button"
                                className={`btn flex-grow-1 text-capitalize ${displayFrequency === freq ? 'btn-primary active' : 'btn-light'}`}
                                onClick={(e) => { e.stopPropagation(); onSelect(tier.tierName, planForFreq.id); }}>
                                {label.toLowerCase()}
                            </button>
                        )
                    })}
                </div>

                <div className="price-display my-3">
                    <span className="h2 fw-bolder">${planToShow.finalPrice.toFixed(2)}</span>
                    <span className="text-muted small">{getIntervalUnit(planToShow.paymentFrequency.frequency)}</span>
                </div>
            </div>
        </div>
    );
};

const Step4_Confirmation = ({ data, setData, nextStep, apiParams, guestAccessToken, apiData, apiLoading, apiError, noPendingOrders, setNoPendingOrders, isActiveOrder, isCancelledSubs }) => {
    const { subscription, user } = data;


    console.log("frequency new...", subscription.frequency)
    const [displayFrequency, setDisplayFrequency] = useState(subscription.frequency || 'MONTHLY');

    useEffect(() => {
        // This effect syncs the local displayFrequency state with the
        // frequency from the selected subscription prop.
        if (subscription.frequency) {
            setDisplayFrequency(subscription.frequency);
        }
    }, [subscription.frequency]);

    const handlePlanSelect = (tierName, planId) => {
        const selectedTier = apiData?.subscriptions?.[0]?.tiers.find(t => t.tierName === tierName);
        const selectedPlan = selectedTier?.plans.find(p => p.id === planId);

        if (selectedPlan) {
            setData(prev => ({
                ...prev,
                subscription: {
                    ...prev.subscription,
                    tierName: tierName,
                    tierPlanCode: selectedPlan.code,
                    planId: selectedPlan.id,
                    planName: selectedPlan.planName,
                    frequency: selectedPlan.paymentFrequency.frequency,
                    price: selectedPlan.finalPrice
                }
            }));

            // trackEvent('select_plan', {
            //     plan_name: selectedPlan.planName,
            //     tier: selectedTier.tierName,
            //     frequency: selectedPlan.paymentFrequency.frequency,
            //     price: selectedPlan.finalPrice,
            //     currency: selectedPlan.currency
            // });

            setDisplayFrequency(selectedPlan.paymentFrequency.frequency);
            setNoPendingOrders(false);
        }
    };

    const activationFeeProduct = apiData?.products?.find(p => p.productType === 'ACTIVATION_FEE');
    const activationFee = activationFeeProduct && !isCancelledSubs ? activationFeeProduct.finalPrice : 0;
    const totalDue = activationFee + subscription.price;

    return (
        <div className="step-content">
            <style>{`
                .confirmation-summary .list-group-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 0;
                    padding-right: 0;
                }
                .confirmation-summary .label {
                    font-weight: 500;
                    color: #6c757d;
                }
                .confirmation-summary .value {
                    font-weight: 500;
                    text-align: right;
                }
                .confirmation-summary .total .label {
                    font-size: 1.1rem;
                    color: var(--bs-primary);
                }
                .confirmation-summary .total .value {
                    font-size: 1.25rem;
                }
                
                /* --- MOBILE RESPONSIVE STYLES --- */
                @media (max-width: 768px) {
                    .confirmation-summary .list-group-item {
                        /* Stack list items vertically on small screens */
                        flex-direction: column;
                        align-items: flex-start;
                        margin-bottom: 0.75rem;
                        padding-bottom: 0.75rem;
                        border-bottom: 1px solid #eee !important;
                    }
                     .confirmation-summary .list-group-item:last-child {
                        border-bottom: none !important;
                     }
                    .confirmation-summary .value {
                        text-align: left;
                        margin-top: 0.25rem;
                        font-weight: bold;
                        color: #212529;
                    }
                    .confirmation-summary .total {
                        flex-direction: row; /* Keep total on one line */
                        align-items: baseline;
                    }
                }
            `}</style>

            <h2 className="step-title text-center">Review Your Order</h2>
            <p className="step-subtitle text-center">Please review your details and confirm your selected plan before proceeding</p>

            {apiLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading Plans...</span>
                    </div>
                </div>
            ) : apiError ? (
                <div className="text-danger" style={{ textAlign: "center", fontSize: "16px", marginTop: "2rem" }}>{apiError}</div>
            ) : (
                <>
                    <div className="mb-4">
                        <div className="row g-3">
                            {apiData?.subscriptions?.[0]?.tiers.map(tier => (
                                <div className="col-md-6 col-lg-4" key={tier.id}>
                                    <PlanSelectionCard
                                        tier={tier}
                                        deviceTypeId={apiParams.device_type}
                                        currentSelection={subscription}
                                        onSelect={handlePlanSelect}
                                        displayFrequency={displayFrequency}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card confirmation-card mt-4">
                        <div className="card-body">
                            <h5 className="card-title fw-bold">Order Summary</h5>
                            {noPendingOrders ? isActiveOrder ?
                                <div className="text-danger" style={{ textAlign: "center", fontSize: "16px", margin: "2rem" }}>{"No previous order found. Please select a plan to proceed."}</div>
                                :
                                <div className="text-danger" style={{ textAlign: "center", fontSize: "16px", margin: "2rem" }}>{"Your previous subscription plan is no longer available. Please select a new plan to continue."}</div>
                                :
                                <ul className="list-group list-group-flush confirmation-summary mb-3">
                                    <li className="list-group-item">
                                        <span className="label">Plan:</span>
                                        <span className="value">{(subscription.tierName || '').replace('Acuma', '').replace('SUBS_', '').replace('Intl', '')}</span>
                                    </li>
                                    <li className="list-group-item">
                                        <span className="label">Device:</span>
                                        <span className="value">{apiParams.device_type === 1 ? 'iOS' : 'Android'}</span>
                                    </li>
                                    <li className="list-group-item">
                                        <span className="label">Billing:</span>
                                        <span className="value text-capitalize">{(subscription.frequency || '').toLowerCase()}</span>
                                    </li>
                                    <li className="list-group-item">
                                        <span className="label">Subscription Price:</span>
                                        <span className="value">${(subscription.price || 0).toFixed(2)}</span>
                                    </li>
                                    {/* {activationFee > 0 && */}
                                    <li className="list-group-item">
                                        <span className="label">Activation Fee:</span>
                                        <span className="value">${activationFee.toFixed(2)}</span>
                                    </li>
                                    {/* } */}
                                    <li className="list-group-item total">
                                        <strong className="label">Total Due Today:</strong>
                                        <strong className="value text-primary">${totalDue.toFixed(2)}</strong>
                                    </li>
                                </ul>
                            }
                            <h5 className="card-title fw-bold mt-4">Profile Details</h5>
                            <ul className="list-group list-group-flush confirmation-summary">
                                <li className="list-group-item"><span className="label">Name:</span><span className="value">{user.firstName} {user.lastName}</span></li>
                                <li className="list-group-item"><span className="label">Email:</span><span className="value">{user.email}</span></li>
                                <li className="list-group-item"><span className="label">Date of Birth:</span><span className="value">{formatDate(user.dateOfBirth)}</span></li>
                                <li className="list-group-item"><span className="label">Gender:</span><span className="value">{user.gender === 'M' ? 'Male' : 'Female'}</span></li>
                                <li className="list-group-item"><span className="label">Address:</span><span className="value">{`${user.address}, ${user.city}, ${user.state}, ${user.zipcode}, ${user.country}`}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
                        <button onClick={() => {
                            // trackEvent('begin_checkout', {
                            //     plan_name: subscription.planName,
                            //     price: subscription.price,
                            //     frequency: subscription.frequency
                            // });
                            nextStep();
                        }} className="btn btn-success" disabled={noPendingOrders}>CONFIRM & PROCEED TO PAYMENT</button>
                    </div>
                </>
            )
            }
        </div >
    );
};

export default Step4_Confirmation;
